import { AsyncPipe, CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { DashboardState } from "../shared/store/dashboard.state";
import { CitoApplicationModule, User } from "./../shared/model/model";

@Component({
  selector: "app-candidate-list",
  styleUrls: ["candidatelist.component.scss"],
  standalone: true,
  imports: [CommonModule, AsyncPipe],
  template: `
    <div
      class="d-flex tooltip-container"
      style="flex: 0 0 3rem; justify-content: center;"
      *ngFor="let d of candidates; let i = index"
    >
      <img
        class="photo"
        [src]="
          'assets/Emoji/' +
          d.emoji.split('  ').join(' ').split(' ').join('_') +
          '.png'
        "
        (click)="selectCandidate.emit(d.id)"
      />
      <span
        *ngIf="(citomodule$ | async) === citomodules.Rekenen"
        class="tooltiptext"
      >
        <span>{{ d.name }}</span>
        <span *ngIf="d.yearGroup">, {{ d.yearGroup }}</span>
        <span *ngIf="d.learningRoutesList[0]"
          >, {{ d.learningRoutesList[0] }}</span
        >
        <span *ngIf="!d.learningRoutesList[0]">, Geen profiel</span>
      </span>
      <span
        *ngIf="(citomodule$ | async) === citomodules.Spelling"
        class="tooltiptext"
      >
        <span>{{ d.name }}</span>
        <span *ngIf="d.yearGroup">, {{ d.yearGroup }}</span>
        <span *ngIf="d.learningRoutesSpellingList[0]"
          >, {{ d.learningRoutesSpellingList[0] }}</span
        >
        <span *ngIf="!d.learningRoutesSpellingList[0]">, Geen profiel</span>
      </span>
      <span class="initials"
        >{{ d.firstname.charAt(0) }}{{ d.inserts }}.{{
          d.lastname.charAt(0)
        }}</span
      >
    </div>
  `,
})
export class CandidateListComponent {
  public citomodule$: Observable<CitoApplicationModule>;
  public citomodules = CitoApplicationModule;
  @Input() candidates: Array<User>;
  @Output() selectCandidate = new EventEmitter<string>();

  re = /\b(\w)/g;

  constructor(private store: Store) {
    this.citomodule$ = store.select(DashboardState.citomodule);
  }
}
